import { Configuration } from '.'

export interface IConfigurationState {
  data: Configuration | null
  isLoading: boolean
  error: string | null
}

export const initialState: IConfigurationState = {
  data: null,
  isLoading: false,
  error: null,
}
